import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Logger, SettingsService } from '@kailona/core';
import './AdminSettings.styl';
var logger = new Logger('main.PluginManager');

var AdminSettings = /*#__PURE__*/function (_Component) {
  _inherits(AdminSettings, _Component);

  var _super = _createSuper(AdminSettings);

  function AdminSettings(props) {
    var _this;

    _classCallCheck(this, AdminSettings);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "updateIndicator", function (settingsName, success) {
      var saveIndicators = _this.state.saveIndicators; // Show the save indicator

      saveIndicators[settingsName] = success;

      _this.setState({
        saveIndicators: saveIndicators
      }); // Dismiss the success save indicator 2 secs later


      if (success) {
        setTimeout(function () {
          saveIndicators[settingsName] = null;

          _this.setState({
            saveIndicators: saveIndicators
          });
        }, 2000);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onChange", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(key, value) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(_this.settingsCache[key] === value)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                _this.settingsCache[key] = value;
                _context.prev = 3;
                _context.next = 6;
                return _this.settingsService.saveAdminSettings(_this.settingsCache);

              case 6:
                _this.updateIndicator(key, true);

                _context.next = 13;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](3);
                logger.error(_context.t0);

                _this.updateIndicator(key, false);

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[3, 9]]);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }());

    _this.state = {
      saveIndicators: {
        fhirBaseUrl: null,
        fhirUsername: null,
        fhirPassword: null
      },
      settings: _this.props.settings
    };
    _this.settingsCache = _this.props.settings;
    _this.settingsService = new SettingsService();
    return _this;
  }

  _createClass(AdminSettings, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var settings;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (this.state.settings) {
                  _context2.next = 6;
                  break;
                }

                _context2.next = 3;
                return this.settingsService.retrieveAdminSettings();

              case 3:
                settings = _context2.sent;
                this.settingsCache = settings;
                this.setState({
                  settings: settings
                });

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return /*#__PURE__*/React.createElement("div", {
        className: "admin-settings-container"
      }, /*#__PURE__*/React.createElement("h2", null, t('ehr', 'FHIR Server')), /*#__PURE__*/React.createElement("p", null, t('ehr', 'FHIR is required to store health data. Basic HTTP Authentication is currently supported.')), /*#__PURE__*/React.createElement("div", {
        className: "fhir-server-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "fhir-server-content"
      }, /*#__PURE__*/React.createElement("label", null, t('ehr', 'Base URL')), /*#__PURE__*/React.createElement("input", {
        type: "text",
        defaultValue: this.state.settings.fhirBaseUrl,
        placeholder: "FHIR Base URL",
        onBlur: function onBlur(e) {
          return _this2.onChange('fhirBaseUrl', e.currentTarget.value);
        }
      }), this.state.saveIndicators.fhirBaseUrl === true && /*#__PURE__*/React.createElement("span", {
        className: "icon icon-checkmark-color"
      }), this.state.saveIndicators.fhirBaseUrl === false && /*#__PURE__*/React.createElement("span", {
        className: "icon icon-error-color",
        title: t('ehr', 'Failed to save changes!')
      })), /*#__PURE__*/React.createElement("div", {
        className: "fhir-server-content"
      }, /*#__PURE__*/React.createElement("label", null, t('ehr', 'Username')), /*#__PURE__*/React.createElement("input", {
        type: "text",
        defaultValue: this.state.settings.fhirUsername,
        placeholder: "FHIR Username",
        onBlur: function onBlur(e) {
          return _this2.onChange('fhirUsername', e.currentTarget.value);
        }
      }), this.state.saveIndicators.fhirUsername === true && /*#__PURE__*/React.createElement("span", {
        className: "icon icon-checkmark-color"
      }), this.state.saveIndicators.fhirUsername === false && /*#__PURE__*/React.createElement("span", {
        className: "icon icon-error-color",
        title: t('ehr', 'Failed to save changes!')
      })), /*#__PURE__*/React.createElement("div", {
        className: "fhir-server-content"
      }, /*#__PURE__*/React.createElement("label", null, t('ehr', 'Password')), /*#__PURE__*/React.createElement("input", {
        type: "password",
        defaultValue: this.state.settings.fhirPassword,
        placeholder: "FHIR Password",
        onBlur: function onBlur(e) {
          return _this2.onChange('fhirPassword', e.currentTarget.value);
        }
      }), this.state.saveIndicators.fhirPassword === true && /*#__PURE__*/React.createElement("span", {
        className: "icon icon-checkmark-color"
      }), this.state.saveIndicators.fhirPassword === false && /*#__PURE__*/React.createElement("span", {
        className: "icon icon-error-color",
        title: t('ehr', 'Failed to save changes!')
      }))));
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return AdminSettings;
}(Component);

_defineProperty(AdminSettings, "propTypes", {
  settings: PropTypes.shape({
    fhirBaseUrl: PropTypes.string.isRequired,
    fhirUsername: PropTypes.string.isRequired,
    fhirPassword: PropTypes.string.isRequired
  })
});

export { AdminSettings as default };
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(logger, "logger", "/home/runner/html/nextcloud/apps/ehr/js/platform/main/src/components/AdminSettings/AdminSettings.js");
  reactHotLoader.register(AdminSettings, "AdminSettings", "/home/runner/html/nextcloud/apps/ehr/js/platform/main/src/components/AdminSettings/AdminSettings.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();